<script setup lang="ts">
import InputSwitch from 'primevue/inputswitch';
import { useAppConfigStore } from '../stores/app-config-store';

const configStore = useAppConfigStore();
</script>

<template>
    <InputSwitch
        v-model="configStore.closeOnEscape"
        class="app-layout-close-on-escape-switch"
    />
</template>
